export const routeName = {
    ROUTER_ROOT: 'RouterRoot',
    LOGIN: 'Login',
    WELCOME: 'Welcome',
    // 공지
    /** 바로고 공지사항 */
    BAROGO_NOTICE: 'BarogoNotice',
    BAROGO_NOTICE_DETAIL: 'BarogoNoticeDetail',
    /** 회원사 업무문의 */
    MEMBER_COMPANY_INQUIRY: 'MemberCompanyInquiry',
    /** 회원사 업무문의 상세보기 */
    MEMBER_COMPANY_INQUIRY_DETAIL: 'MemberCompanyInquiryDetail',
    /** 회원사 업무문의 등록 */
    MEMBER_COMPANY_INQUIRY_CREATE: 'MemberCompanyInquiryCreate',
    /** 회원사 업무문의 수정 */
    MEMBER_COMPANY_INQUIRY_EDIT: 'MemberCompanyInquiryEdit',
    // 총판점 공지사항 관련
    /** 총판점 공지사항 리스트 조회 */
    DISTRIBUTOR_NOTICE: 'DistributorNotice',
    /** 총판점 공지사항 등록 */
    DISTRIBUTOR_NOTICE_CREATE: 'DistributorNoticeCreate',
    /** 총판점 공지사항 수정 */
    DISTRIBUTOR_NOTICE_EDIT: 'DistributorNoticeEdit',
    /** 총판점 공지사항 상세보기 */
    DISTRIBUTOR_NOTICE_DETAIL: 'DistributorNoticeDetail',
    // 상점 업무처리
    /** 상점 업무처리 리스트 조회 */
    STORE_WORK_PROCESS: 'StoreWorkProcess',
    /** 상점 업무처리 글 생성 */
    STORE_WORK_PROCESS_CREATE: 'StoreWorkProcessCreate',
    /** 상점 업무처리 글 수정 */
    STORE_WORK_PROCESS_EDIT: 'StoreWorkProcessEdit',
    /** 상점 업무처리 답변 생성 */
    STORE_WORK_PROCESS_CREATE_REPLY: 'StoreWorkProcessCreateReply',
    /** 상점 업무처리 답변 수정 */
    STORE_WORK_PROCESS_EDIT_REPLY: 'StoreWorkProcessEditReply',
    /** 상점 업무처리 리스트 조회 */
    STORE_WORK_PROCESS_DETAIL: 'StoreWorkProcessDetail',
    // 라이더 공지사항 관련
    /** 라이더 공지사항 */
    WORKER_NOTICE: 'WorkerNotice',
    /** 라이더 공지사항 */
    WORKER_NOTICE_CREATE: 'WorkerNoticeCreate',
    /** 라이더 공지사항 */
    WORKER_NOTICE_EDIT: 'WorkerNoticeEdit',
    /** 라이더 공지사항 */
    WORKER_NOTICE_DETAIL: 'WorkerNoticeDetail',
    /** 세부지명 요청 */
    REQUEST_MAP: 'RequestMap',
    /** 세부지명 요청 등록 */
    REQUEST_MAP_CREATE: 'RequestMapCreate',
    /** 정산서 다운로드 */
    REPORT_DOWNLOAD: 'ReportDownload',
    /** 캐쉬 이동 설정 */
    BAROMONEY_TRANSFER_SETTING: 'BaromoneyTransferSetting',
    /** 캐쉬 이동 설정 상세보기 */
    BAROMONEY_TRANSFER_SETTING_DETAIL: 'BaromoneyTransferSettingDetail',
    /** 캐쉬이동 미수금 리스트 */
    BAROMONEY_ACCOUNT_RECEIVABLE_LIST: 'BaromoneyAccountReceivableList',
    /** 캐쉬이동 미지급 리스트 */
    BAROMONEY_ACCRUED_EXPENSES_LIST: 'BaromoneyAccruedExpensesList',
    // 관제
    /** 지도관제 */
    MAP_CONTROL: 'MapControl',
    /** 운행설정 */
    OPERATION_SETTING: 'OperationSetting',
    /** 배달내역 */
    DELIVERY_HISTORY: 'DeliveryHistory',
    /** 목록관제 */
    LIST_CONTROL: 'ListControl',
    /** 라이더 정산 */
    WORKER_ADJUSTMENT: 'WorkerAdjustment',
    /** 상점 정산 */
    STORE_ADJUSTMENT: 'StoreAdjustment',
    STORE_ADJUSTMENT_DETAIL: 'StoreAdjustmentDetail',
    WITHHOLD_TAX_REPORT: 'WithholdTaxReport',
    PAYMENT_DETAIL: 'PaymentDetail',
    SIMPLE_PAYMENT_DETAIL: 'SimplePaymentDetail',
    DETAILS_PER_WORKER: 'DetailsPerWorker',
    DETAILS_PER_WORKER_DETAIL: 'DetailsPerWorkerDetail',
    WORKER_INFORMATION_DETAIL: 'WorkerInformationDetail',
    /** 상점 통계 */
    STORE_STATS: 'StoreStats',
    STORE_STATS_DAILY: 'StoreStatsDaily',
    STORE_STATS_MONTHLY: 'StoreStatsMonthly',
    STORE_STATS_HOURLY: 'StoreStatsHourly',
    STORE_STATS_DAY_OF_WEEK: 'StoreStatsDayOfWeek',
    STORE_STATS_SHARE_STORE: 'StoreStatsShareStore',
    /** 허브 통계 */
    HUB_STATS: 'HubStats',
    HUB_STATS_DAILY: 'HubStatsDaily',
    HUB_STATS_MONTHLY: 'HubStatsMonthly',
    HUB_STATS_HOURLY: 'HubStatsHourly',
    HUB_STATS_DAY_OF_WEEK: 'HubStatsDayOfWeek',
    /** 바로머니 리포트 */
    BAROMONEY_REPORT: 'BaromoneyReport',
    BAROMONEY_REPORT_BASIC: 'BaromoneyReportBasic',
    BAROMONEY_REPORT_PERIOD_COMPARISON: 'BaromoneyReportPeriodComparsion',
    /** 라이더 관리 */
    WORKER_MANAGEMENT: 'WorkerManagement',
    /** 라이더 바로머니 내역 */
    WORKER_BAROMONEY_HISTORY: 'WorkerBaromoneyHistory',
    /** 라이더 수익 */
    WORKER_PROFIT: 'WorkerProfit',
    /** 라이더 출근표 */
    WORKER_MONTHLY_ATTENDANCE: 'WorkerMonthlyAttendance',
    /** 라이더수수료그룹설정 */
    WORKER_MANAGEMENT_DELIVERY_FEE_GROUP_SETTING: 'WorkerManagementDeliveryFeeGroupSetting',
    /** 자동차감그룹설정 */
    WORKER_MANAGEMENT_CASH_AUTO_DEDUCT_GROUP_SETTING: 'WorkerManagementCashAutoDeductGroupSetting',
    /** 자동차감그룹설정 */
    WORKER_MANAGEMENT_ALLOCATED_CANCEL_PENALTY_GROUP_SETTING: 'WorkerManagementAllocatedCancelPenaltyGroupSetting',
    /** 라이더 등록 */
    WORKER_MANAGEMENT_WORKER_CREATE: 'WorkerManagementWorkerCreate',
    /** 라이더 상세정보 보기 */
    WORKER_MANAGEMENT_WORKER_DETAIL: 'WorkerManagementWorkerDetail',
    /** 라이더 상세정보 수정 */
    WORKER_MANAGEMENT_WORKER_EDIT: 'WorkerManagementWorkerEdit',
    /** 라이더 상세정보 > 근무정보 수정 */
    WORKER_MANAGEMENT_WORKER_EDIT_WORK_INFO: 'WorkerManagementWorkerEditWorkInfo',
    /** 라이더 상세정보 > 배달설정 수정 */
    WORKER_MANAGEMENT_WORKER_EDIT_DELIVERY_SETTING: 'WorkerManagementWorkerEditDeliverySetting',
    /** 라이더 상세정보 > 차량/면허/보험수정 */
    WORKER_MANAGEMENT_WORKER_EDIT_PRIVATE_INFO: 'WorkerManagementWorkerEditPrivateInfo',
    /** 라이더 통계 */
    WORKER_STATISTICS: 'WorkerStatistics',
    /** 상점 관리 */
    STORE_MANAGEMENT: 'StoreManagement',
    /** 상점 그룹별 라이더 수수료 설정 */
    STORE_MANAGEMENT_WORKER_FEE_PER_STORE_GROUP_SETTING: 'StoreManagementWorkerFeePerStoreGroupSetting',
    /** 상점 등록 */
    STORE_MANAGEMENT_CREATE: 'StoreManagementCreate',
    /** 상점 상세정보 보기 */
    STORE_MANAGEMENT_DETAIL: 'StoreManagementDetail',
    /** 상점 상세정보 수정 */
    STORE_MANAGEMENT_EDIT: 'StoreManagementEdit',
    /** 상점 상세정보 > 일반정보 수정 */
    STORE_MANAGEMENT_EDIT_BASIC_INFO: 'StoreManagementEditBasicInfo',
    /** 상점 상세정보 > 비용설정 수정 */
    STORE_MANAGEMENT_EDIT_FEE_SETTING: 'StoreManagementEditFeeSetting',
    /** 상점 상세정보 > 접수 및 운행설정 수정 */
    STORE_MANAGEMENT_EDIT_OPERATION_SETTING: 'StoreManagementEditOperationSetting',
    /** 허브 관리 */
    HUB_MANAGEMENT: 'HubManagement',
    /** 허브 등록 */
    HUB_MANAGEMENT_CREATE: 'HubManagementCreate',
    /** 허브 상세정보 보기 */
    HUB_MANAGEMENT_DETAIL: 'HubManagementDetailDetail',
    /** 허브 상세정보 수정 */
    HUB_MANAGEMENT_EDIT: 'HubManagementEdit',
    /** 허브 상세정보 > 일반정보 수정 */
    HUB_MANAGEMENT_EDIT_BASIC_INFO: 'HubManagementEditBasicInfo',
    /** 허브 상세정보 > 소속 라이더 운행설정 수정 */
    HUB_MANAGEMENT_EDIT_WORKER_OPERATION_SETTING: 'HubManagementEditWorkerOperationSetting',
    /** 허브 상세정보 > 정산 및 운행설정 수정 */
    HUB_MANAGEMENT_EDIT_ADJUSTMENT_OPERATION_SETTING: 'HubManagementEditAdjustmentOperationSetting',
    /** 허브 정산 */
    HUB_ADJUSTMENT: 'HubAdjustment',
    /** 허브 정산 > 메인 */
    HUB_ADJUSTMENT_MAIN: 'HubAdjustmentMain',
    /** 허브 정산 > 일별 매출 */
    HUB_ADJUSTMENT_DAILY_SALES: 'HubAdjustmentDailySales',
    /** 허브 정산 > 일별 매출 > 상세 정보 */
    HUB_ADJUSTMENT_DAILY_SALES_DETAIL: 'HubAdjustmentDailySalesDetail',
    /** 허브 정산 > 일별 매입 */
    HUB_ADJUSTMENT_DAILY_PURCHASE: 'HubAdjustmentDailyPurchase',
    /** 허브 정산 테스트 모드 집입 */
    HUB_ADJUSTMENT_TEST_MODE_ENTRANCE: 'HubAdjustmentTestModeEntrance',
    /** 사용자 관리 > List */
    USER_MANAGEMENT: 'UserManagement',
    /** 사용자 관리 > 등록 */
    USER_MANAGEMENT_CREATE: 'UserManagementCreate',
    /** 사용자 관리 > 상세/수정 */
    USER_MANAGEMENT_PAGE: 'UserManagementPage',
    /** 배달대행료 */
    POLICY_DELIVERY_AMOUNT: 'PolicyDeliveryAmount',
    /** 공유 관리 */
    SHARE_MANAGEMENT: 'ShareManagement',
    /** 공유 설정 */
    SHARE_MANAGEMENT_CONFIG: 'ShareManagementConfig',
    /** 구역 설정 */
    DELIVERY_CHARGE_AREA_CONTROL: 'DeliveryChargeAreaControl',
    /** 라이더 배차 */
    WORKER_ALLOCATE: 'WorkerAllocate',
    /** 출발도착관제 */
    LOCATION_CONTROL: 'LocationControl',
    /** 매출 */
    SALES: 'Sales',
    /** 매출 > 허브 바로머니 */
    SALES_HUB_BAROMONEY: 'SalesHubBaromoney',
    /** 매출 > 허브 바로머니 일별 상세 */
    SALES_HUB_BAROMONEY_DAILY_DETAIL: 'SalesHubBaromoneyDailyDetail',
    /** 매출 > 상점 바로머니 */
    SALES_STORE_BAROMONEY: 'SalesStoreBaromoney',
    /** 매출 > 상점 바로머니 일별 상세 */
    SALES_STORE_BAROMONEY_DAILY_DETAIL: 'SalesStoreBaromoneyDailyDetail',
    /** 매출 > Invoice내역 */
    SALES_INVOICE: 'SalesInvoice',
    /** 출금요청 팝업 */
    WITHDRAWAL_REQUEST: 'WithdrawalRequest',
    /** 라이더 상세정보 팝업 */
    WORKER_DETAIL: 'WorkerDetail',
    // 이하 테스트
    /** 디자인 시스템 */
    DESIGN_SYSTEM_TEXT: 'DesignSystemText',
    DESIGN_SYSTEM_FORM: 'DesignSystemForm',
    DESIGN_SYSTEM_BUTTON: 'DesignSystemButton',
    /** 테스트용 */
    TEMPORARY: 'Temporary',
    VALIDATION_COMPOSITION_API: 'ValidationCompositionApi',
    VALIDATION_OPITION_API: 'ValidationOptionApi',
};
